"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDonationFormMagicalLink = exports.getMembershipRenewalLink = exports.getTicketingMagicalLink = exports.generateMagicalLink = exports.getUserQueryParams = void 0;
const queryString = __importStar(require("query-string"));
const currency_1 = require("../helpers/currency");
const routes_1 = require("../routes/routes");
const thresholdPercentage = [105, 115, 130, 150];
const calculateMagicalAmounts = (lastAmountPaid) => {
    const amountsRoundsToFive = thresholdPercentage.map((threshold) => {
        return roundToFiveOrZero((threshold * lastAmountPaid) / 100);
    });
    return amountsRoundsToFive.reduce((calculatedAmounts, current) => {
        const prev = calculatedAmounts[calculatedAmounts.length - 1];
        if (current - prev < 5) {
            return [...calculatedAmounts, prev + 5];
        }
        if (current < 5) {
            return [...calculatedAmounts, 5];
        }
        return [...calculatedAmounts, current];
    }, []);
};
const roundToFiveOrZero = (value) => {
    const restToFive = value % 5;
    if (restToFive > 2.5) {
        return Math.round(value + (5 - restToFive));
    }
    else {
        return Math.round(value - restToFive);
    }
};
const getUserQueryParams = (user, amount) => {
    const punctualAmounts = amount && calculateMagicalAmounts((0, currency_1.getDollarValue)(amount));
    return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        address: user?.address,
        city: user?.city,
        postalCode: user?.postalCode,
        state: user?.region, // Use state instead of region cause &reg is interpreted as ® in html
        country: user?.country,
        amount: amount ? (0, currency_1.getDollarValue)(amount) : undefined,
        punctualAmounts: punctualAmounts
            ? `[${punctualAmounts[0]}, ${punctualAmounts[1]}, ${punctualAmounts[2]}, ${punctualAmounts[3]}]`
            : "[]",
    };
};
exports.getUserQueryParams = getUserQueryParams;
const generateMagicalLink = (frontendUrl, user, magicalLinkPath, amount) => {
    const queryParams = (0, exports.getUserQueryParams)(user, amount);
    return `${frontendUrl}/${user.locale.toLowerCase()}${magicalLinkPath}?${queryString.stringify(queryParams)}`;
};
exports.generateMagicalLink = generateMagicalLink;
const getTicketingMagicalLink = (frontendUrl, user, path) => {
    return (0, exports.generateMagicalLink)(frontendUrl, user, `${routes_1.FrontendRoutes.TicketingPage}${path}`);
};
exports.getTicketingMagicalLink = getTicketingMagicalLink;
const getMembershipRenewalLink = ({ frontendUrl, ticketingPath, isoLocale, user, rateId, }) => {
    const params = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        address: user.address,
        city: user.city,
        postalCode: user.postalCode,
        state: user.region,
        country: user.country,
        rateId,
    };
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            queryParams.set(key, String(value));
        }
    });
    const query = queryParams.toString();
    const queryPrefix = query ? `?${query}` : "";
    return `${frontendUrl}${(0, routes_1.getTicketingLink)(ticketingPath, isoLocale)}${queryPrefix}`;
};
exports.getMembershipRenewalLink = getMembershipRenewalLink;
const getDonationFormMagicalLink = (frontendUrl, user, donationForm, amount) => {
    const magicalLinkPath = (0, routes_1.getFormLink)(donationForm, null);
    return (0, exports.generateMagicalLink)(frontendUrl, user, magicalLinkPath, amount);
};
exports.getDonationFormMagicalLink = getDonationFormMagicalLink;
